module.exports = __webpack_public_path__ + "97e21cb59cce58cfc21152e335cc4e6f.svg";